import { KeyValue } from '@angular/common';
import { PaginationSetting } from '@grid/abstractions';

export const paginationSettings: PaginationSetting = {
  currentPage: 1,
  rowByPage: 10,
  totalItems: 0,
};

export const paginationOptions: KeyValue<string, number>[] = [
  { key: '10 / Page', value: 10 },
  { key: '15 / Page', value: 15 },
  { key: '20 / Page', value: 20 },
  { key: '25 / Page', value: 25 },
];

export const portfolioPaginationOptions: KeyValue<string, number>[] = [
  ...paginationOptions,
  { key: '100 / Page', value: 100 },
  { key: '250 / Page', value: 250 },
  { key: '500 / Page', value: 500 },
];
